import moment from 'moment';

import { createContext, useEffect, useMemo, useState } from 'react';
import { gettingEmployees, gettingTags } from 'utils/Filter';
import { getMonth } from 'utils/Times';
import { useTranslation } from 'react-i18next';
import { Avatar, Box } from '@mui/material';
import { getAvatar } from 'utils/Styles';
import { getGridStringOperators } from '@mui/x-data-grid-pro';
import { HireDate } from './HireDate';
import { Orgpath } from './Orgpath';

const Context = createContext({});

const ContextProvider = ({ children, value }) => {
    const { t } = useTranslation();

    const [tableDateRange, setTableDateRange] = useState([moment(getMonth().start_date), moment(getMonth().end_date)]);

    // Filter
    const [tags, setTags] = useState([]);
    const [tag, setTag] = useState([]);
    const [filterTags, setFilterTags] = useState('');
    const [loadingGettingTags, setLoadingGettingTags] = useState(false);

    const [employees, setEmployees] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [filterEmployees, setFilterEmployees] = useState('');
    const [loadingGettingEmployees, setLoadingGettingEmployees] = useState(false);

    // table
    const [contextMenu, setContextMenu] = useState(null);
    const [rows, setRows] = useState([]);
    const [checked, setChecked] = useState([]);
    const [loadingGettingEmployeeInfo, setLoadingGettingEmployeeInfo] = useState(false);

    const [openAssignTag, setOpenAssignTag] = useState(false);
    const [openAddEmployee, setOpenAddEmployee] = useState(false);
    const [openEditEmployee, setOpenEditEmployee] = useState(false);
    const [openAssignContract, setOpenAssignContract] = useState(false);
    const [openAssignPosition, setOpenAssignPosition] = useState(false);
    const [openDeactivateEmployee, setOpenDeactivateEmployee] = useState(false);
    const [openAssignAccrualProfile, setOpenAssignAccrualProfile] = useState(false);
    const [openAssignScheduleRule, setOpenAssignScheduleRule] = useState(false);
    const [openAssignPayRule, setOpenAssignPayRule] = useState(false);

    const reloading = async () => {
        console.log(
            'reloading',
            tags.map((tag) => tag),
        );
        await gettingEmployees(
            setLoadingGettingEmployeeInfo,
            setEmployees,
            setEmployee,
            setRows,
            tags.filter((tg) => tg.name.toLowerCase().includes(filterTags.toLocaleLowerCase())).map((tg) => tg.id),
            'employee',
            {
                start_date: tableDateRange[0].format('YYYY-MM-DD'),
                end_date: tableDateRange[1].format('YYYY-MM-DD'),
                tags_id_in: tags.map((tag) => tag.id).join(','),
                without_hiring: true,
            },
        );

        /* await employeeService
            .getEmployees(
                moment(tableDateRange[0]).format("YYYY-MM-DD"),
                moment(tableDateRange[1]).format("YYYY-MM-DD")
            )
            .then((response) => {
                setRows(
                    response.map((e) => {
                        const orgpaths = e.orgpath.sort((a, b) =>
                            moment(a.Range.end_date).diff(
                                moment(b.Range.end_date)
                            )
                        );

                        const orgpathInRangeOfSearch = orgpaths.filter((o) =>
                            rangeOverlap(
                                tableDateRange[0],
                                tableDateRange[1],
                                moment(
                                    o?.Range?.start_date,
                                    "YYYY-MM-DDTHH:mm:ss"
                                ),
                                moment(
                                    o?.Range?.end_date,
                                    "YYYY-MM-DDTHH:mm:ss"
                                )
                            )
                        );

                        console.log(
                            "orgpathInRangeOfSearch",
                            orgpathInRangeOfSearch
                        );

                        // el hire_date es el rango del contrato activo o
                        return {
                            ...e,
                            id: e.employee_id,
                            full_name: `${e.first_name} ${e.last_name}`,
                            person_number: e.document_employee,
                            hire_date: orgpathInRangeOfSearch,
                            term_date: moment(
                                e.contract_end_date,
                                "YYYY-MM-DDTHH:mm:ss"
                            ).format("YYYY-MM-DD"),
                            closed_period: moment(
                                e.pay_period_end,
                                "YYYY-MM-DDTHH:mm:ss"
                            ).format("YYYY-MM-DD"),
                            org_path: orgpathInRangeOfSearch,
                        };
                    })
                );
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setLoadingGettingEmployeeInfo(false);
            }); */
    };

    const columns = useMemo(
        () => [
            {
                field: 'avatar',
                headerName: t('timekeeper.employees.table.columns.avatar'),
                width: 60,
                minWidth: 60,
                disableColumnMenu: true,
                sortable: false,
                resizable: false,
                headerAlign: 'center',
                align: 'center',
                renderHeaderFilter: () => null,
                renderCell: (params) => {
                    return (
                        <Box sx={{ pt: 1, pb: 1 }}>
                            <Avatar
                                sx={{
                                    bgcolor: getAvatar(params.row.full_name),
                                }}
                            >
                                {params.row.full_name.charAt(0)}
                            </Avatar>
                        </Box>
                    );
                },
            },
            {
                field: 'full_name',
                headerName: t('timekeeper.employees.table.columns.full_name'),
                flex: 2,
                minWidth: 200,
                filterOperators: getGridStringOperators().filter((operator) => operator.value !== 'isAnyOf'),
            },
            {
                field: 'person_number',
                headerName: t('timekeeper.employees.table.columns.person_number'),
                flex: 0.5,
                minWidth: 150,
                filterOperators: getGridStringOperators().filter((operator) => operator.value !== 'isAnyOf'),
            },
            {
                field: 'hire_date',
                headerName: t('timekeeper.employees.table.columns.hire_date'),
                flex: 1,
                minWidth: 250,
                filterOperators: getGridStringOperators().filter((operator) => operator.value !== 'isAnyOf'),
                renderCell: (params) => <HireDate params={params} />,
            },
            {
                field: 'org_path',
                headerName: t('timekeeper.employees.table.columns.org_path'),
                flex: 2,
                minWidth: 260,
                filterOperators: getGridStringOperators().filter((operator) => operator.value !== 'isAnyOf'),
                renderCell: (params) => <Orgpath params={params} />,
            },
            {
                field: 'closed_period',
                headerName: t('timekeeper.employees.table.columns.closed_period'),
                flex: 1,
                minWidth: 130,
                filterOperators: getGridStringOperators().filter((operator) => operator.value !== 'isAnyOf'),
            },
            {
                field: 'active',
                headerName: t('timekeeper.employees.table.columns.status.title'),
                flex: 0.5,
                minWidth: 120,
                filterOperators: getGridStringOperators().filter((operator) => operator.value !== 'isAnyOf'),
                valueFormatter: (value) => {
                    return value ? t('timekeeper.employees.table.columns.status.active') : t('timekeeper.employees.table.columns.status.inactive');
                },
            },
        ],
        [t],
    );

    useEffect(() => {
        gettingTags(setLoadingGettingTags, setTags, setTag, setEmployees, setEmployee, setRows, 'employee', {
            start_date: tableDateRange[0].format('YYYY-MM-DD'),
            end_date: tableDateRange[1].format('YYYY-MM-DD'),
            without_hiring: true,
        });
        // eslint-disable-next-line
    }, []);

    return (
        <Context.Provider
            value={{
                ...value,
                tableDateRange,
                setTableDateRange,
                tags,
                setTags,
                tag,
                setTag,
                filterTags,
                setFilterTags,
                loadingGettingTags,
                setLoadingGettingTags,
                employees,
                setEmployees,
                employee,
                setEmployee,
                filterEmployees,
                setFilterEmployees,
                loadingGettingEmployees,
                setLoadingGettingEmployees,
                loadingGettingEmployeeInfo,
                setLoadingGettingEmployeeInfo,
                rows,
                setRows,
                columns,
                checked,
                setChecked,
                contextMenu,
                setContextMenu,
                openAssignTag,
                setOpenAssignTag,
                openAddEmployee,
                setOpenAddEmployee,
                openEditEmployee,
                setOpenEditEmployee,
                openAssignContract,
                setOpenAssignContract,
                openAssignPosition,
                setOpenAssignPosition,
                openDeactivateEmployee,
                setOpenDeactivateEmployee,
                reloading,
                openAssignAccrualProfile,
                setOpenAssignAccrualProfile,
                openAssignScheduleRule,
                setOpenAssignScheduleRule,
                openAssignPayRule,
                setOpenAssignPayRule,
            }}
        >
            {children}
        </Context.Provider>
    );
};

export { Context, ContextProvider };
